module.exports = __webpack_public_path__ + "static/media/benefits.710286d3.svg";